import React, { forwardRef } from 'react';

import { Alert } from '@mui/material';

import CustomLensView, { type CustomLensViewHandle, type CustomLensViewProps } from './CustomLensView';

/** The presentation receives the saved Lens/data bridge; a pending view never replaces that definition. */
const LensCustomViewPresentation = forwardRef<CustomLensViewHandle, CustomLensViewProps & { pending: boolean }>(
  function LensCustomViewPresentation({ pending, ...props }, ref) {
    return (
      <>
        {pending && (
          <Alert severity="info" sx={{ mb: 1 }}>
            Previewing askRichard’s proposed custom view. It is not saved yet: choose Save changes or Discard in the
            chat.
          </Alert>
        )}
        <CustomLensView ref={ref} {...props} />
      </>
    );
  },
);

export default LensCustomViewPresentation;
